import logo from "./logo.svg";
import "./App.css";
import React from "react";

function useDeviceType(uastring = window.navigator.userAgent) {
  let [state, setState] = React.useState(null);

  React.useEffect(() => {
    let didRun = true;

    try {
      if (didRun) {
        if (/Android/i.test(window.navigator.userAgent)) {
          setState("Android");
        } else if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
          setState("iOS");
        } else {
          setState("Other");
        }
      }
    } catch (err) {
      if (didRun) {
        setState(null);
      }
    }

    return () => {
      didRun = false;
    };
  }, [setState, uastring]);

  return state;
}

function App() {
  const deviceType = useDeviceType();

  return (
    <div className="App">
      <header className="App-header">
        <img className="App-logo" src="/bee.svg" alt="bee" />
        <p>beebee</p>

        {deviceType === "Other" && (
          <p>
            Desktop application not available, please open this page in your
            mobile device
          </p>
        )}
        {deviceType !== null && deviceType !== "Other" && (
          <a className="App-button-link">
            <div className="App-button">
              {deviceType === "Android" && <p>Download on Play Store</p>}
              {deviceType === "iOS" && <p>Download on App Store</p>}
            </div>
          </a>
        )}
        {/* <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
      </header>
    </div>
  );
}

export default App;
